import glamorous from 'glamorous'
import PropTypes from 'prop-types'

import { COLORS } from 'config'

/** Circular image of a person. */
const Avatar = glamorous.img({
  display: 'block',
  width: 80,
  height: 80,
  backgroundColor: COLORS.silver,
  objectFit: 'cover',
  borderRadius: '50%'
})

Avatar.propTypes = {
  /** URL of the image */
  src: PropTypes.string.isRequired
}

export default Avatar



// WEBPACK FOOTER //
// ./src/components/profile/Avatar.js